import React from 'react';
import Proptypes from 'prop-types';
import Loader from 'react-loader-advanced';
import { getSaxsExperimentsBySessionId } from './IORequests';
import { parseExperiments } from '../../../helpers/Saxs/SaxsExperimentsMapper';

class SaxsExperimentListContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            experiments: [],
            error: null,
            fetched: false,
            fetching: true,
            selectedExperimentId: null,
        };

        this.onExperimentClicked = this.onExperimentClicked.bind(this);
    }

    render() {
        if (this.state.fetched === true) {
            return this.props.children(this.state.experiments, this.state.selectedExperimentId, this.onExperimentClicked)
        } else {
            return (<Loader show={this.state.fetching} message='Loading'>
                <div style={{ backgroundColor: 'white', width: '100px', height: '100px' }} />
            </Loader>)
        }
    }

    /**
     * This method will retrieve the experiments for a given session. An experiment might be calibration, sample changer or HPLC
     */
    componentDidMount() {
        const onSuccess = (response) => {
            this.setState({ experiments: parseExperiments(response.data), fetching: false, fetched: true });
        };

        const onError = (error) => {
            this.setState({ error: error, fetching: false, fetched: false });
        };

        getSaxsExperimentsBySessionId(this.props.token, this.props.proposal, this.props.sessionId, onSuccess, onError);
    }

    /**
     * It is triggered from a child when a experiment has been selected
     */
    onExperimentClicked(experiment) {
        this.setState({ selectedExperimentId: experiment.experimentId });
    }
}

export default SaxsExperimentListContainer;

SaxsExperimentListContainer.proptypes = {
    /** ispyb backend authentication token */
    token: Proptypes.string
}


// WEBPACK FOOTER //
// ./src/containers/saxs/helpers/SaxsExperimentListContainer.js